import { render } from "./EmailRecipientsInputs.vue?vue&type=template&id=4ecd53ce&scoped=true"
import script from "./EmailRecipientsInputs.vue?vue&type=script&lang=js"
export * from "./EmailRecipientsInputs.vue?vue&type=script&lang=js"

import "./EmailRecipientsInputs.vue?vue&type=style&index=0&id=4ecd53ce&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecd53ce"]])

export default __exports__